import { GET_COMPANY_KNOWLEDGE_GUIDE, GET_COMPANY_KNOWLEDGE_GUIDE_SUCCESS, GET_KNOWLEDGE_CENTER, GET_KNOWLEDGE_CENTER_FAIL, GET_KNOWLEDGE_CENTER_SUCCESS, GET_KNOWLEDGE_GUIDE_LINKS, GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS } from "./constants";

export const getKnowledgeCenter = (payload) =>({
    type: GET_KNOWLEDGE_CENTER,
    payload
})
export const getKnowledgeCenterSuccess = (payload) =>({
    type: GET_KNOWLEDGE_CENTER_SUCCESS,
    payload
})
export const getKnowledgeCenterFail = (payload) =>({
    type: GET_KNOWLEDGE_CENTER_FAIL,
    payload
})


export const getCompanyKnowledgeGuide = () =>({
    type: GET_COMPANY_KNOWLEDGE_GUIDE
})


export const getCompanyKnowledgeGuideSuccess = (payload) =>({
    type: GET_COMPANY_KNOWLEDGE_GUIDE_SUCCESS,
    payload
})

export const getCompanyKnowledgeGuideFailed = (payload) =>({
    type: GET_COMPANY_KNOWLEDGE_GUIDE,
    payload
})


export const getKnowledgeGuideLinks = () =>({
    type: GET_KNOWLEDGE_GUIDE_LINKS
})


export const getKnowledgeGuideLinksSuccess = (payload) =>({
    type: GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS,
    payload
})

export const getKnowledgeGuideLinksFailed = (payload) =>({
    type: GET_KNOWLEDGE_GUIDE_LINKS_SUCCESS,
    payload
})